import { TmrBaseResource, responseErrorCheck, api } from 'stylewhere/api'

export class Asns extends TmrBaseResource {
  static endpoint = 'api/v1/asns'

  static async asnContent(operationId: string, asnId: string, groupedBy: string) {
    const endpoint = `${this.endpoint}/${asnId}/asnContent`
    const result = await api.get(endpoint, {
      operationId,
      groupedBy
    })
    return responseErrorCheck(result)
  }
}
